import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { spacer40, screenSmMax } from '@spotify-internal/encore-web';
import { FeaturedContentHeadline } from '../../ui';
import { TwoUpSegment } from './TwoUpSegment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TwoUp = styled.div.withConfig({
  displayName: "TwoUpFeaturedContentModule__TwoUp",
  componentId: "sc-1k3n538-0"
})(["display:flex;flex-direction:column;"]);
var Bottom = styled.div.withConfig({
  displayName: "TwoUpFeaturedContentModule__Bottom",
  componentId: "sc-1k3n538-1"
})(["display:flex;flex-direction:row;justify-content:flex-start;@media (max-width:", "){flex-direction:column;}"], screenSmMax);
var Left = styled.div.withConfig({
  displayName: "TwoUpFeaturedContentModule__Left",
  componentId: "sc-1k3n538-2"
})(["width:45%;padding-right:", ";@media (max-width:", "){padding-right:0px;width:100%;}"], spacer40, screenSmMax);
var Right = styled.div.withConfig({
  displayName: "TwoUpFeaturedContentModule__Right",
  componentId: "sc-1k3n538-3"
})(["width:45%;padding-left:", ";@media (max-width:", "){padding-left:0px;width:100%;}"], spacer40, screenSmMax);
export var TwoUpModule = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$supertext = _ref.supertext,
      supertext = _ref$supertext === void 0 ? '' : _ref$supertext,
      _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? '' : _ref$headline,
      image = _ref.image,
      _ref$caption = _ref.caption,
      caption = _ref$caption === void 0 ? '' : _ref$caption,
      _ref$segment1Headline = _ref.segment1Headline,
      segment1Headline = _ref$segment1Headline === void 0 ? '' : _ref$segment1Headline,
      _ref$segment1Body = _ref.segment1Body,
      segment1Body = _ref$segment1Body === void 0 ? '' : _ref$segment1Body,
      _ref$segment1LinkText = _ref.segment1LinkText,
      segment1LinkText = _ref$segment1LinkText === void 0 ? '' : _ref$segment1LinkText,
      _ref$segment1LinkUrl = _ref.segment1LinkUrl,
      segment1LinkUrl = _ref$segment1LinkUrl === void 0 ? '' : _ref$segment1LinkUrl,
      segment1Image = _ref.segment1Image,
      _ref$segment2Headline = _ref.segment2Headline,
      segment2Headline = _ref$segment2Headline === void 0 ? '' : _ref$segment2Headline,
      _ref$segment2Body = _ref.segment2Body,
      segment2Body = _ref$segment2Body === void 0 ? '' : _ref$segment2Body,
      _ref$segment2LinkText = _ref.segment2LinkText,
      segment2LinkText = _ref$segment2LinkText === void 0 ? '' : _ref$segment2LinkText,
      _ref$segment2LinkUrl = _ref.segment2LinkUrl,
      segment2LinkUrl = _ref$segment2LinkUrl === void 0 ? '' : _ref$segment2LinkUrl,
      segment2Image = _ref.segment2Image;
  var fchProps = {
    supertext: supertext,
    headline: headline,
    image: image,
    useFeaturedContentHeadline: true,
    caption: caption
  };
  var segment1 = {
    segmentHeadline: segment1Headline,
    segmentBody: segment1Body,
    segmentLinkText: segment1LinkText,
    segmentLinkUrl: segment1LinkUrl,
    segmentImage: segment1Image
  };
  var segment2 = {
    segmentHeadline: segment2Headline,
    segmentBody: segment2Body,
    segmentLinkText: segment2LinkText,
    segmentLinkUrl: segment2LinkUrl,
    segmentImage: segment2Image
  };
  return /*#__PURE__*/_jsxs(TwoUp, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(FeaturedContentHeadline, _objectSpread({}, fchProps)), /*#__PURE__*/_jsxs(Bottom, {
      children: [/*#__PURE__*/_jsx(Left, {
        children: /*#__PURE__*/_jsx(TwoUpSegment, {
          twoUpSegment: segment1
        })
      }), /*#__PURE__*/_jsx(Right, {
        children: /*#__PURE__*/_jsx(TwoUpSegment, {
          twoUpSegment: segment2
        })
      })]
    })]
  });
});